const getActionValue = initialFormValues =>
  initialFormValues.action_url
    ? initialFormValues.action_url.toLowerCase().startsWith('http://')
      ? initialFormValues.action_url
      : null
    : null;
export default getActionValue;
